import {
  colors,
  getBorderRadius,
  getHeight,
  getSpacing,
} from '@cabonline/ui-shared';
import { Button } from '@cabonline/ui-web';
import styled from '@emotion/styled';
import { Link, NavLink, NavLinkProps } from 'react-router-dom';

export const StyledLinkContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${getSpacing('m')};
`;

interface StyledNavLinkProps extends NavLinkProps {
  isFocused?: boolean;
}

export const StyledNavLink = styled(NavLink, {
  shouldForwardProp: (prop) => prop !== 'isFocused',
})<StyledNavLinkProps>`
  text-decoration: none;
  height: ${getHeight('m')};
  border-radius: ${getBorderRadius('m')};
  padding: 0 ${getSpacing('xs')};
  display: flex;
  align-items: center;
  gap: ${getSpacing('xxs')};
  border: ${(p) =>
    p.isFocused ? `1px solid ${colors.white}` : '1px solid transparent'};
  &:hover {
    background-color: ${colors.blackHover};
  }
  &:focus {
    outline: none;
  }
`;

export const StyledLanguageSelect = styled.div`
  margin-right: auto;
  padding-left: ${getSpacing('s')};
  .react-select-container {
    min-width: 120px;
  }
`;

export const StyledLinkButtonWrapper = styled.div`
  margin-left: ${getSpacing('s')};
`;

export const StyledDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: ${colors.white};
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12);
  z-index: 1000;
  min-width: 200px;
  padding: 4px;
  margin-top: 4px;
  white-space: nowrap;
`;

export const StyledDropdownItem = styled(Link)`
  display: block;
  padding: ${getSpacing('s')} ${getSpacing('m')};
  color: ${colors.black};
  text-decoration: none;
  font-weight: 500;
  border-radius: ${getBorderRadius('xs')};
  margin: 0 ${getSpacing('xxs')};
  &:hover {
    background-color: ${colors.gray4};
  }
  &:active {
    background-color: ${colors.gray3};
  }
`;

export const StyledAdminButton = styled(Button)`
  color: ${colors.white};
  font-weight: bold;
  font-size: 16px;
  padding: ${getSpacing('xxs')} ${getSpacing('xs')};
  min-height: auto;
`;
